'use strict';

var MixinClass = function(mixin) {
    this.mixin = mixin;
};

MixinClass.prototype.getMixin = function() {
    return Odigeo._.clone(this.mixin);
};

MixinClass.prototype.extend = function(obj) {
    return Odigeo._.extend({}, this.mixin, obj);
};

MixinClass.prototype.deepExtend = function(obj) {
    return Odigeo._.merge({}, this.mixin, obj);
};

module.exports = MixinClass;
